import styled, { css } from 'styled-components'
import { colors } from '../../const'

export const Container = styled.div(
  ({ tone }) => css`
    align-items: center;
    color: ${tone === 'referible' ? colors.error : tone === 'normal' ? colors.success : colors.textSecondary};
    display: flex;
    font-weight: 600;
    gap: 8px;
  `
)

export const SourceLabel = styled.span`
  color: ${colors.textSecondary};
  margin-right: -4px;
`

export const ResultLabel = styled.span`
  font-weight: 600;
`
